// src/components/Footer.jsx
import { developer } from '../models/portfolioData';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="container">
      <footer className="footer">
        <p className="mb-0">
          Copyright &copy; {year} <span className="font-heading font-semibold text-primary">Mr. Jabiulla</span>. All Rights Reserved.
        </p>

        <div className="social-links">
          <a
            href={developer.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            title="GitHub"
          >
            <i className="ti-github"></i>
          </a>
          <a
            href={developer.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
          >
            <i className="ti-linkedin"></i>
          </a>
          {developer.fiverr && (
            <a
              href={developer.fiverr}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Fiverr"
              title="Fiverr"
            >
              <svg role="img" viewBox="110 120 270 270" width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <circle cx="315.97" cy="162.19" r="26.87" />
                <path d="M345.87,207.66h-123V199.6c0-15.83,15.83-16.13,23.89-16.13,9.25,0,13.44.9,13.44.9v-43.6a155.21,155.21,0,0,0-19.71-1.19c-25.68,0-73.16,7.16-73.16,61.51V208h-22.4v40.31h22.4v85.1h-20.9v40.31H247.34V333.37H222.85v-85.1H290v85.1H269.13v40.31h97.65V333.37H345.87Z" />
              </svg>
            </a>
          )}
          <a
            href={`mailto:${developer.email}`}
            aria-label="Email"
            title="Email"
          >
            <i className="ti-email"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}
